import React from 'react';
import Skeleton from '@/components/feedback/Skeleton';
import { cn } from '@/lib/utils';
import ResponsiveWrapper from '@/components/layout/ResponsiveWrapper';
import type { SkeletonImageProps } from './types';

function SkeletonImage({
  isLoaded,
  responsive = {},
  className,
  children,
  ...props
}: SkeletonImageProps) {
  const classes = cn('absolute inset-0', className);

  return (
    <ResponsiveWrapper responsive={responsive}>
      <div className="relative w-full h-full">
        {!isLoaded && <Skeleton className={classes} {...props} />}
        {children}
      </div>
    </ResponsiveWrapper>
  );
}

export default React.memo(SkeletonImage);
